export default __webpack_public_path__ + "static/media/oladejo.0a6ccfe0.png";